import React, { FC } from 'react'

const UserIcon: FC = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 0C6.23858 0 4 2.23858 4 5C4 7.76142 6.23858 10 9 10C11.7614 10 14 7.76142 14 5C14 2.23858 11.7614 0 9 0Z"
      fill="currentColor"
    />
    <path
      d="M5 12C2.23858 12 0 14.2386 0 17C0 18.6569 1.34315 20 3 20H15C16.6569 20 18 18.6569 18 17C18 14.2386 15.7614 12 13 12H5Z"
      fill="currentColor"
    />
  </svg>
)

export default UserIcon
